import { makeStyles } from '@material-ui/core/styles';

export const ErrorListStyles = makeStyles({
  noMargin: {
    margin: 0,
  },
});
